import classNames from "classnames";
import styles from "@/pages/saleOperations/saleWorkBench/customerDetail/index.module.less";
import {Button, Empty, message, Spin, Tooltip} from "antd";
import {clueSalesValid, getClueButton, getTrackPlanButton} from "@/services/saleOpServices.ts";
import React, {useContext, useEffect, useMemo, useState} from "react";
import ClueDetailContext from "@/pages/clueManage/clueDetail/clueDetailContext.ts";
import {useSetState} from "ahooks";
import {useSearchParams} from "react-router-dom";
import {getAuth, getAuthTabs} from "@/utils/auth.ts";
import {SLowcodeList, SMessage, STags} from "shj-components";
import {getBusinessDictList} from "@/services/product.ts";
import {get} from "lodash-es";
import callIcon from '@/assets/icon-default.png'
import noStartIcon from '@/assets/no-start.png'
import SaleModal from '@/pages/saleOperations/saleWorkBench/customerDetail/components/saleModal';

const ActivityIcon = props => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" { ...props }>
    <path d="M19.8285 22.8918L12.4486 20.0293C12.0737 19.8825 11.6568 19.8825 11.2819 20.0293L4.17945 22.8667C3.93846 22.9616 3.67781 22.9967 3.42012 22.9687C3.16243 22.9408 2.91549 22.8507 2.70073 22.7064C2.48598 22.562 2.30991 22.3678 2.18779 22.1404C2.06568 21.9131 2.00122 21.6595 2 21.4018V3.68698C1.99965 2.97516 2.28352 2.29231 2.78925 1.78848C3.29498 1.28465 3.98119 1.00105 4.69711 1H19.2976C19.6525 0.999827 20.004 1.06921 20.332 1.20418C20.6599 1.33915 20.9579 1.53707 21.2089 1.78661C21.4598 2.03616 21.6589 2.33244 21.7946 2.65851C21.9304 2.98459 22.0002 3.33407 22 3.68698V21.415C22.0002 21.6727 21.9372 21.9267 21.8163 22.1547C21.6954 22.3827 21.5204 22.578 21.3064 22.7235C21.0925 22.869 20.846 22.9604 20.5884 22.9897C20.3309 23.019 20.07 22.9854 19.8285 22.8918Z" fill={props?.style?.color || "#0064FF"}/>
    <path d="M12.6311 6.1416L13.5467 7.998C13.5969 8.10033 13.6714 8.18882 13.7636 8.25576C13.8559 8.32269 13.9631 8.36603 14.0759 8.382L16.1243 8.6796C16.2543 8.69835 16.3764 8.75312 16.4769 8.83772C16.5774 8.92231 16.6521 9.03335 16.6927 9.15825C16.7333 9.28315 16.7381 9.41692 16.7066 9.54441C16.6751 9.6719 16.6085 9.78802 16.5143 9.8796L15.0323 11.3196C14.9508 11.3993 14.8897 11.4976 14.8544 11.6061C14.8191 11.7145 14.8106 11.8299 14.8295 11.9424L15.1799 13.9824C15.2018 14.1118 15.1871 14.2447 15.1376 14.3661C15.088 14.4876 15.0055 14.5928 14.8993 14.6699C14.7932 14.747 14.6676 14.7929 14.5367 14.8025C14.4059 14.812 14.275 14.7848 14.1587 14.724L12.3275 13.764C12.2263 13.7114 12.114 13.684 11.9999 13.684C11.8859 13.684 11.7735 13.7114 11.6723 13.764L9.84112 14.724C9.72489 14.7848 9.59397 14.812 9.46312 14.8025C9.33228 14.7929 9.2067 14.747 9.10054 14.6699C8.99438 14.5928 8.91187 14.4876 8.86229 14.3661C8.81271 14.2447 8.79803 14.1118 8.81993 13.9824L9.17032 11.9424C9.18928 11.8299 9.18074 11.7145 9.14542 11.6061C9.11011 11.4976 9.04907 11.3993 8.96753 11.3196L7.48552 9.8796C7.3914 9.78802 7.3248 9.6719 7.29327 9.54441C7.26174 9.41692 7.26655 9.28315 7.30714 9.15825C7.34773 9.03335 7.42249 8.92231 7.52294 8.83772C7.6234 8.75312 7.74554 8.69835 7.87552 8.6796L9.92393 8.382C10.0368 8.36603 10.144 8.32269 10.2362 8.25576C10.3285 8.18882 10.4029 8.10033 10.4531 7.998L11.3687 6.1416C11.427 6.02398 11.517 5.92498 11.6285 5.85577C11.74 5.78655 11.8687 5.74988 11.9999 5.74988C12.1312 5.74988 12.2598 5.78655 12.3714 5.85577C12.4829 5.92498 12.5729 6.02398 12.6311 6.1416Z" fill="white"/>
  </svg>
)

enum TaskKey {
  SUBMIT_LOST = 'SUBMIT_LOST', // 飞单按钮
  SUBMIT_INVALID = 'SUBMIT_INVALID', // 提交无效
  SUBMIT_PENDING = 'SUBMIT_PENDING', // 提交待定
  SUBMIT_VALID = 'SUBMIT_VALID', // 提交有效
  CONFIRM_TO_SHOP = 'CONFIRM_TO_SHOP', // 确认到店
  APPOINTMENT_STORE = 'APPOINTMENT_STORE', // 预约到店
  ADD_RECORD = 'ADD_RECORD', // 跟进日志
  CALL_PENDING = 'CALL_PENDING', // 呼叫待定
  CALL_VALID = 'CALL_VALID', // 呼叫有效
  CALL_INVALID = 'CALL_INVALID', // 呼叫无效
  APPOINT_DISPATCH = 'APPOINT_DISPATCH', // 指定派单
  DISPATCH = 'DISPATCH', // 派单
  CALL_APPOINTMENT = 'CALL_APPOINTMENT', // 云客服邀约
  DIALING = 'DIALING', // 一键拨号
}

const TaskNode = () => {
  const auth = getAuth()
  const [search] = useSearchParams()
  const saleClueId = search.get('saleClueId')
  const {detailState, trackDetail, updateDetail} = useContext(ClueDetailContext)

  const [state, setState] = useSetState<any>({
    buttons: [],
    chooseButtonKey: '',
    chooseButtonDesc: '',
    dispatchDesignDeptList: [],
    assignDesignDeptLoading: false,
    discardCauseList: [], // 放弃原因
  })

  useEffect(() => {
    getOptions()
  }, []);

  useEffect(() => {
    // console.log(detailState.id, detailState.templateNodeId, trackDetail.id, clueId, detailState.isReloadNode)
    if (saleClueId){
      trackDetail.id && getTrackButton()
    } else {
      detailState.id && getButton()
    }
  }, [detailState.id, detailState.templateNodeId, trackDetail.id, saleClueId, detailState.isReloadNode]);

  const getTrackButton = async () => {
    const buttons = [];
    const res =  await getTrackPlanButton(trackDetail.id)
    buttons.push(...res)
    console.log('getTrackButton')
    setState({buttons})
  }

  const getButton = async () => {
    console.log('getButton', detailState.templateNodeId, trackDetail.id)
    if (detailState.status === 'DESIGN' && !detailState.templateNodeId) return;
    if (detailState.status === 'TO_SHOP' && !detailState.templateNodeId && !detailState.salesTemplateId) return;
    const buttons = [];

    if (['DESIGN', 'TO_SHOP'].includes(detailState.status) && detailState.templateNodeId || trackDetail.id) {
      const trackBtn = await getTrackPlanButton(detailState.templateNodeId || trackDetail.id)
      buttons.push(...trackBtn)
      console.log('getClueButton: trackButton')
    }
    const clueBtn = await getClueButton(detailState.id)
    buttons.push(...clueBtn)
    console.log('getClueButton')
    setState({buttons})
  }

  const getOptions = () => {
    getBusinessDictList({ data: { priKey: 'Zabandonreason', enabled: true } }).then(res => {
      const list = get(res, '[0].children[0].children', [])
      setState({ discardCauseList: list })
    })
    getBusinessDictList({ data: { priKey: 'ZPendingreason', enabled: true } }).then(res => {
      const list = get(res, '[0].children[0].children', [])
      setState({ pendingCauseList: list })
    })
  }

  const reload = () => {
    updateDetail({isReload: !detailState.isReload, isReloadRecord: !detailState.isReloadRecord, isReloadTrack: !detailState.isReloadTrack, isReloadNode: !detailState.isReloadNode})
  }

  const buttons = useMemo(() => {
    const obj  = {};
    const btns = [...state.buttons]
    if(auth['viewCaseBtn']) {btns.push({buttonKey: 'VIEW_CASE', buttonDesc: '去提案大师'})}
    if(auth['designMasterBtn']) {btns.push({buttonKey: 'DESIGN_MASTER', buttonDesc: '去设计大师'})}
    return btns.reduce((res, item) => {
      if(!obj[item.buttonKey]){
        obj[item.buttonKey] = true
        res.push(item)
      }
      return res
    }, [])
  }, [state.buttons])

  return (
    <div
      className={styles.taskNodeOverScrollBox}
      style={(!saleClueId && ['DESIGN', 'TO_SHOP'].includes(detailState.status)) ? {height: 'calc(100vh - 610px)'} : {}}
    >
      {buttons.length ? buttons.map((item, i) => {
        return (
          <div
            key={item.buttonKey}
            className={classNames([styles.nodeWrapBox, styles.mb10])}
          >
            <div className={styles.activityOperate}>
              <div className={classNames([styles.mr20, styles.activityOperateInfo])}>
                <div className={classNames(styles.flexStartCenter)}>
                  <ActivityIcon style={{ fontSize: 24, flexShrink: 0, color: 'var(--theme-color)', marginRight: '10px' }} />
                  <span className={classNames([styles.nodeTitle, styles.mr10])}>{item.buttonDesc}</span>
                  {/*<STags itemKey='' label='线上' bgColor="transparent" borderWidth='1px' borderRadius='3px' borderColor='rgba(0, 100, 255, 1)' fontColor='rgba(0, 100, 255, 1)'></STags>*/}
                </div>
                {/*<div className={styles.operateStatus}>
                  <img className={styles.operateStatusImg} src={noStartIcon} />
                </div>*/}
              </div>
              <div className={styles.buttonList}>
                <SaleModal
                  useBtnKey={true}
                  disabledAuth={true}
                  detailState={detailState}
                  trackDetail={trackDetail}
                  reload={reload}
                  state={state}
                  setState={setState}
                  buttonList={[item]}
                >
                </SaleModal>
              </div>
            </div>
            {/*<div className={styles.activityInfo}>任务标准：营销员在标准时间内（当日21点后派单从次日9点开始计时）完成电话呼叫，并了解客户基本信息（客户姓名/称呼、性别、交房时间、楼盘、建筑面积、房屋类型、房屋属性、装修风格等）</div>*/}
            <div className={styles.activityInfo}>{item.buttonDesc}</div>
          </div>)
      }) : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>}
    </div>
  )
}

export default TaskNode